<template>
  <div class="select-card-modal">
    <el-dialog
      title="批量添加搜索关键词"
      :visible.sync="dialogVisible"
      width="700px"
      :append-to-body="true"
    >
      <div class="modal-body">
        <div class="filter-header">
          <el-form
            :model="filterData"
            ref="filterFormRef"
            :rules="rules"
            label-width="70px"
          >
            <el-form-item label="匹配方式" prop="match_type">
              <el-select
                v-model="filterData.match_type"
                placeholder="请选择匹配方式"
                class="filter-select"
              >
                <el-option label="短语" value="PHRASE"></el-option>
                <el-option label="广泛" value="EXTENSIVE"></el-option>
                <el-option label="精确" value="PRECISION"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <el-input
          resize="none"
          type="textarea"
          :rows="10"
          placeholder="每行一个关键字，每个关键字不超过30字符（15个中文），回车换行"
          v-model="textarea"
        >
        </el-input>
      </div>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmData">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "QuickLaunch",
  data() {
    return {
      dialogVisible: false,
      filterData: {
        match_type: null,
      },
      textarea: "",
      rules: {
        match_type: [
          {
            required: true,
            message: "请选择匹配方式",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    confirmData() {
      this.$refs.filterFormRef.validate((valid) => {
        if (valid) {
          let keyList = this.textarea
            .split("\n")
            .map((item) => item.trim())
            .filter((item) => item !== "");
          this.$emit("selectOk", {
            match_type: this.filterData.match_type,
            wordList: keyList,
          });
          this.dialogVisible = false;
        }
      });
    },
    showModal() {
      this.filterData.match_type = null;
      this.textarea = "";
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.modal-body {
  .filter-header {
    .filter-select {
    }
  }
}
</style>